import React from 'react';
import InputButton from './inputs/inputButton';
import InputSet from './inputs/inputSet';
import INPUTS from './inputs/applyInputs';

const AromataseInhibitors = () => {
  return (
    <InputSet title="Aromatase inhibitors"
      tooltipText="Aromatase inhibitors can be used to decrease gynecomastia or increase the effects of steroids.
                   However, AIs can also have adverse effects, like sexual dysfunction or decreased bone density.">
      <InputButton data={INPUTS.anastrazole}/>
      <InputButton data={INPUTS.exemestane}/>
    </InputSet>
  )
}

const Diuretics = () => {
  return (
    <InputButton data={INPUTS.diuretics}
      tooltipText="Diuretics can decrease body fat by decreasing water retention. However, usage
                   increases the risk for conditions such as electrolyte abnormalities."
    />
  )
}

const HCG = () => {
  return (
    <InputButton data={INPUTS.hcg}
      tooltipText="Human chorionic gonadotropin (hCG) can be used as post-cycle therapy to help the body
                   restore its natural testosterone production."/>
  )
}

const HGH = () => {
  return (
    <InputButton data={INPUTS.hgh}
      tooltipText="Human growth hormone (hGH) can be used to increase muscle mass, but usage may lead to
                   adverse effects like high cholesterol and heart disease."
    />
  )
}

const Injection = () => {
  return (
    <InputSet title="Steroid Injections">
      <InputButton data={INPUTS.injection}/>
    </InputSet>
  )
}

const Oral = () => {
  return (
    <InputSet title="Oral Steroids">
      <InputButton data={INPUTS.oral}/>
    </InputSet>
  );
}

const SARMs = () => {
  return (
    <InputButton data={INPUTS.sarms}
      tooltipText="Selective androgen receptor modulators (SARMs) can increase muscle mass.
                   Usage can increase risk of abnormalities in several parts of the body, such as the liver."
    />
  )
}

const SERMs = () => {
  return (
    <InputSet title="SERMs"
      tooltipText="Selective estrogen receptor modulators (SERMs) can be used to decrease estrogenic side effects, like gynecomastia.
                   SERMs are often used as post-cycle therapy to aid recovery of the HPA axis.">
      <InputButton data={INPUTS.clomiphene}/>
      <InputButton data={INPUTS.tamoxifen}/>
    </InputSet>
  )
}

const Insulin = () => {
  return (
    <InputButton data={INPUTS.insulin}
      tooltipText="Insulin can be used to decrease body fat, but it can lead to increased risk of
                   diabetes or blood sugar abnormalities."
    />
  )
}

const GameInputs = () => {
  return (
    <div>
      <h3>Inputs</h3>
      <Injection/>
      <Oral/>
      <SERMs/>
      <AromataseInhibitors/>
      <InputSet title="Other performance enhancing drugs">
        <div className="other-peds">
          <Insulin/>
          <HGH/>
          <Diuretics/>
          <SARMs/>
          <HCG/>
        </div>
      </InputSet>
    </div>
  );
}

export default GameInputs;